module.exports = __webpack_public_path__ + "static/media/broed-b.4eaf5317.mp3";